var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
  _vm.useContainer ? 'container-rel' : '',
  _vm.fullWidth ? 'fullWidth' : '',
  _vm.colClass
]},[_c('div',{class:[
    _vm.useContainer ? 'inner-container' : '',
    _vm.fullWidth ? 'fullWidth' : ''
  ]},[_c('div',{class:[
      'container-title',
      _vm.fullWidth ? 'fullWidth' : '',
      _vm.subtitle ? '' : ''
    ]},[_c('h6',{staticClass:"title-rel m-0 p-0"},[_vm._v(_vm._s(_vm.title))]),(_vm.subtitle)?_c('p',{class:'subtitle-rel m-0 p-0'},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")]):_vm._e()]),_vm._t("default")],2),(_vm.link)?_c('div',{staticClass:"see-more"},[_c('router-link',{staticClass:"text-blue-500",attrs:{"to":_vm.link}},[_vm._v(" Ver detalhes "),_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"21","height":"20","viewBox":"0 0 21 20","fill":"none"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.71967 5.21967C9.01256 4.92678 9.48744 4.92678 9.78033 5.21967L14.0303 9.46967C14.3232 9.76256 14.3232 10.2374 14.0303 10.5303L9.78033 14.7803C9.48744 15.0732 9.01256 15.0732 8.71967 14.7803C8.42678 14.4874 8.42678 14.0126 8.71967 13.7197L12.4393 10L8.71967 6.28033C8.42678 5.98744 8.42678 5.51256 8.71967 5.21967Z","fill":"#0854C5"}})])])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }